import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ConsumableTypeService } from '../proxy/general/controllers/consumable-type.service';
import { Plant } from '@general/plant/plant';
import { GasOilAndLubricant } from '@general/gas-oil-and-lubricant/gas-oil-and-lubricant';
import { Material } from '@general/material/material';
import { Chemical } from '@general/chemical/chemical';
import { ReasonService } from '../proxy/general/controllers/reason.service';
import { VendorService } from '@controlling/proxy/controlling/controllers';
import { InternalOrderService } from '@controlling/proxy/controlling/controllers';

FieldBuilder.setNamespace('General');

export const CONSUMABLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('code', 'Entity.Consumable.Code')
    .required()
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('name', 'Entity.Consumable.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.Consumable.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('deactivationReasonId', 'Entity.Person.DeactivationReason', ReasonService)
    .displayFromNested('deactivationReason.name')
    .sortBy('deactivationReason.name')
    .build(),
  FieldBuilder
    .date('deactivationDate', 'Entity.Consumable.DeactivationDate')
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.Consumable.SapCode')
    .maxLength(20)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.Consumable.Notes')
    .maxLength(300)
    .build(),
  FieldBuilder
    .foreignKey('consumableTypeId', 'Entity.ConsumableType', ConsumableTypeService)
    .required()
    .displayFromNested('consumableType.name')
    .sortBy('consumableType.name')
    .build(),
];

export const CONSUMABLE_CONFIG = {
  entityName: 'Consumable',
  localizationKey: 'General::Entity.Consumable',
  fields: CONSUMABLE_FIELDS,
  permission: 'GeneralConsumables.Consumables',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
  getChildren: (row: any, allChildren: any[]) => {
    const consumableType = row?.consumableType;
    if (!consumableType) {
      return [];
    }
    const consumableTypeName = consumableType.entityName || consumableType.name;
    if (!consumableTypeName) {
      return [];
    }
    const lowerTypeName = consumableTypeName.toLowerCase();
    return allChildren.filter(child => child.entityName.toLowerCase() === lowerTypeName);
  },
  children: [
    {
      entityName: 'GasOilAndLubricant',
      foreignKeyField: 'consumableId',
      localizationKey: 'General::Entity.GasOilAndLubricant',
      component: GasOilAndLubricant,
    },
    {
      entityName: 'Plant',
      foreignKeyField: 'consumableId',
      localizationKey: 'General::Entity.Plant',
      component: Plant,
    },
    {
      entityName: 'Material',
      foreignKeyField: 'consumableId',
      localizationKey: 'General::Entity.Material',
      component: Material,
    },
    {
      entityName: 'Chemical',
      foreignKeyField: 'consumableId',
      localizationKey: 'General::Entity.Chemical',
      component: Chemical,
    },
  ]
};
